import { createContext, use } from 'react';

import type { UserLanguage } from '~/api/user/types';

import { noop } from '~/utils/functions';

export const LanguageContext = createContext<{
  language: UserLanguage;
  setLanguage: (language: (UserLanguage | null) | ((old: UserLanguage | null) => UserLanguage | null)) => void;
  setPreviewLanguage: (language: UserLanguage | null) => void;
}>({
  language: 'nl',
  setLanguage: noop,
  setPreviewLanguage: noop,
});

export const useLanguageContext = () => use(LanguageContext);
